<template>
  <div :class="getCss('wrap')" :style="wrapStyle">
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
export default {
  name: 'CTgclubLogo',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'tgclub-logo-',
      astConfigInfo: '', // 业务配置项
    };
  },
  computed: {
    // 组件最外层容器配置样式
    wrapStyle() {
      let backgroundStyle = {
        backgroundImage: `url(${this?.astConfigInfo?.LOGO_URL || ''})`,
      };
      // 编辑器内
      if (this.$isInEditor) {
        backgroundStyle = {
          backgroundImage: `url(${this.configurationData.editorShowLogo || 'https://act.xinyue.qq.com/test/activity/commercial/11040/2d92657973ca83364718d83d4faa6c34.gif'})`,
        };
      }
      return {
        ...this.styles.base,
        ...backgroundStyle,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      };
    },
  },
  created() {
    this.astConfigInfo = this.$ast?.currentAstConfig();
    console.log('astConfigInfo= logo', this.astConfigInfo);
  },
  mounted() {
    console.log('version 1.0.10 tgclub logo  configurationData=', this.configurationData, this.$ast?.currentAstConfig());
  },
  methods: {},
};
</script>
<style lang="scss">
@import './styles.scss';

</style>
